import { createContext, useContext, useState, type ReactNode } from "react";

interface VenueSwitcherContextType {
  impersonatingVenueId: string | null;
  impersonatingVenueName: string | null;
  startImpersonating: (venueId: string, venueName: string) => void;
  stopImpersonating: () => void;
}

const VenueSwitcherContext = createContext<VenueSwitcherContextType | null>(null);

export function VenueSwitcherProvider({ children }: { children: ReactNode }) {
  const [impersonatingVenueId, setImpersonatingVenueId] = useState<string | null>(null);
  const [impersonatingVenueName, setImpersonatingVenueName] = useState<string | null>(null);

  const startImpersonating = (venueId: string, venueName: string) => {
    setImpersonatingVenueId(venueId);
    setImpersonatingVenueName(venueName);
  };

  const stopImpersonating = () => {
    setImpersonatingVenueId(null);
    setImpersonatingVenueName(null);
  };

  return (
    <VenueSwitcherContext.Provider
      value={{
        impersonatingVenueId,
        impersonatingVenueName,
        startImpersonating,
        stopImpersonating,
      }}
    >
      {children}
    </VenueSwitcherContext.Provider>
  );
}

export function useVenueSwitcher() {
  const context = useContext(VenueSwitcherContext);
  if (!context) {
    throw new Error("useVenueSwitcher must be used within VenueSwitcherProvider");
  }
  return context;
}
